import React from "react";
import { IconButton, Badge } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";

const CustomExpansionControl = ({ row, expandedRows, setExpandedRows, applicationsCount, isRowExpandable }) => {
  const isExpanded = expandedRows.includes(row.id);
  const enabled = isRowExpandable();

  // Count applications without flags
  const unflaggedCount = row.job_applications?.filter(app => !app.flag || app.flag === "pending").length || 0;
  const hasUnflagged = unflaggedCount > 0;

  const handleToggle = () => {
    if (!enabled) return;

    const newExpandedRows = isExpanded
      ? expandedRows.filter(id => id !== row.id)
      : [...expandedRows, row.id];
    setExpandedRows(newExpandedRows);
  };

  return (
    <IconButton onClick={handleToggle} size="small" disabled={!enabled} style={{ color: enabled ? "inherit" : "grey" }}>
      <Badge
        badgeContent={applicationsCount}
        sx={{
          "& .MuiBadge-badge": {
            minWidth: "26px",
            backgroundColor: hasUnflagged ? "#ff9800" : "#4caf50",
            color: "white"
          }
        }}
      >
        {isExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
      </Badge>
    </IconButton>
  );
};

export default CustomExpansionControl;
